// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let AlgorithmSubscribeMessage = function (fieldSet)
{
    this.Code = Message.CODE_PFIX_ALGORITHM_SUBSCRIBE_MESSAGE
    PFixMessage.call(this, fieldSet)
}

AlgorithmSubscribeMessage.prototype = Object.create(PFixMessage.prototype)

AlgorithmSubscribeMessage.prototype.setAlgorithmId = function (algorithmId)
{
    this.setFieldValue(FieldsFactory.FIELD_ALGORITHM_ID, algorithmId)
}

AlgorithmSubscribeMessage.prototype.getAlgorithmId = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ALGORITHM_ID)
}

AlgorithmSubscribeMessage.prototype.setSubscribeAction = function (action)
{
    this.setFieldValue(FieldsFactory.FIELD_SUBSCRIPTION_ACTION, action)
}

AlgorithmSubscribeMessage.prototype.getSubscribeAction = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_SUBSCRIPTION_ACTION)
}